import { defineAction } from '~/prix'
import { z } from 'zod'
import materialCreateAction from './materialCreate.action.json' with { type: 'json' }
import { materialObject } from '../materialObject'

const materialCreateDefinition = defineAction({
  ...materialCreateAction,

  input: materialObject
    .pick({
      id: true,
      name: true,
      type: true,
      description: true,
      buyDate: true,
      noteNumber: true,
      supplier: true,
    })
    .partial({ id: true }),
  output: z.object({ id: materialObject.shape.id }),
})

export default materialCreateDefinition
